<template>
    <div class="flex justify-end">
        <jet-dropdown v-if="canShowActions" align="right" width="48" class="relative z-[9999]">
            <template #trigger>
                <button class="flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-150 ease-in-out">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                    </svg>
                </button>
            </template>

            <template #content>
                <button @click="changeEmail"
                        v-if="showChangeEmail"
                        class="block w-full px-4 py-2 text-left text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
                    Change Email
                </button>
                <button @click="promoteMember"
                        v-if="showPromote"
                        class="block w-full px-4 py-2 text-left text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
                    Promote to Admin
                </button>
                <button @click="demoteMember"
                        v-if="showDemote"
                        class="block w-full px-4 py-2 text-left text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
                    Demote to Member
                </button>
                <button @click="removeMember"
                        v-if="showRemove"
                        class="block w-full px-4 py-2 text-left text-sm leading-5 text-red-600 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
                    Remove Member
                </button>
            </template>
        </jet-dropdown>
        <span v-else class="text-gray-400">—</span>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    data: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['event']);

const showPromote = computed(() => props.data.role === 'member');
const showDemote = computed(() => props.data.role === 'admin');
const showRemove = computed(() => props.data.role !== 'owner');
const showChangeEmail = computed(() => Boolean(props.data.can_update_email));
const canShowActions = computed(() => showPromote.value || showDemote.value || showRemove.value || showChangeEmail.value);

const removeMember = () => {
    emit('event', 'remove-member');
};

const promoteMember = () => {
    emit('event', 'promote-member');
};

const demoteMember = () => {
    emit('event', 'demote-member');
};

const changeEmail = () => {
    emit('event', 'change-email');
};
</script>
